<template>
  <div class="p-4">
    <!-- Header -->
    <div class="mb-4">
      <button @click="router.push('/pedidos')" class="text-violet-600 hover:text-violet-700 dark:text-violet-400 flex items-center mb-2 text-sm">
        <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
        Volver a Pedidos
      </button>
      <h1 class="text-xl font-bold text-gray-900 dark:text-white">Nuevo Pedido</h1>
      <p class="text-sm text-gray-600 dark:text-gray-400">Crear pedido manual para agregar cotizaciones</p>
    </div>

    <!-- Formulario -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
      <form @submit.prevent="crearPedido">
        <div class="space-y-4">
          <!-- Cliente -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Cliente <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.contacto_id"
              required
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white text-sm"
            >
              <option value="">Seleccionar cliente...</option>
              <option v-for="contacto in contactos" :key="contacto.id" :value="contacto.id">
                {{ contacto.razon_social || `${contacto.nombre} ${contacto.apellido_paterno}` }}
              </option>
            </select>
          </div>

          <!-- Folio del Cliente -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Folio/Referencia del Cliente
            </label>
            <input
              v-model="form.folio_cliente"
              type="text"
              placeholder="Ej: OC-12345"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white text-sm"
            />
          </div>

          <!-- Referencia -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Referencia Adicional
            </label>
            <input
              v-model="form.referencia"
              type="text"
              placeholder="Ej: Proyecto ABC"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white text-sm"
            />
          </div>

          <!-- Fecha Entrega Requerida -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Fecha de Entrega Requerida
            </label>
            <input
              v-model="form.fecha_entrega_requerida"
              type="date"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white text-sm"
            />
          </div>

          <!-- Notas -->
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Notas
            </label>
            <textarea
              v-model="form.notas"
              rows="3"
              placeholder="Instrucciones especiales, condiciones de pago, etc."
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white text-sm"
            ></textarea>
          </div>
        </div>

        <!-- Botones -->
        <div class="flex justify-end gap-3 mt-6">
          <button
            type="button"
            @click="router.push('/pedidos')"
            class="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 text-sm"
          >
            Cancelar
          </button>
          <button
            type="submit"
            :disabled="loading"
            class="px-4 py-2 bg-violet-600 text-white rounded-md hover:bg-violet-700 disabled:bg-gray-400 text-sm"
          >
            {{ loading ? 'Creando...' : 'Crear Pedido' }}
          </button>
        </div>
      </form>

      <div v-if="error" class="mt-4 text-red-500 text-sm">{{ error }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useHttp } from '@/composables/useHttp'
import { useNotifications } from '@/composables/useNotifications'

const router = useRouter()
const { get, post, loading, error, data } = useHttp()
const { showSuccess, showError } = useNotifications()

const contactos = ref([])
const form = ref({
  contacto_id: '',
  folio_cliente: '',
  referencia: '',
  fecha_entrega_requerida: '',
  notas: ''
})

// Cargar contactos
const fetchContactos = async () => {
  try {
    await get('contactos')
    if (data.value) {
      contactos.value = data.value.data || data.value
    }
  } catch (err) {
    showError('Error al cargar contactos')
  }
}

// Crear pedido
const crearPedido = async () => {
  try {
    await post('pedidos', form.value)
    if (data.value) {
      showSuccess('Pedido creado exitosamente')
      router.push(`/pedidos/${data.value.pedido.id}`)
    }
  } catch (err) {
    showError('Error al crear pedido')
  }
}

onMounted(() => {
  fetchContactos()
})
</script>
